import React from 'react';
import config from 'config';

import { StyledMenuItem } from './styled';

const ShippersList = ({ shippers }) => {
  return (
    <ul>
      {shippers.map((shipper) => (
        <li key={shipper.id}>
          <StyledMenuItem to={`${config.BASE_ROUTE}shipper-contracts/${shipper.id}`}>
            {shipper.company_name}
          </StyledMenuItem>
        </li>
      ))}
    </ul>
  );
};

export default ShippersList;
